export enum OrderStepsEnum {
  VehicleInformation = 1,
  Parts = 2,
  Summary = 3
}